import React from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../CategoryContext';
import Card from './card';
import MobileCard from './mobileCard';
import './index.scss';

const source = 'gallery-listing';

const MainContent = ({ items }) => (
    <AppContext.Consumer>
        {({ isTouch }) => (
            !isTouch ?
                (
                    <div className="main-content-wrapper">
                        <div className="main-content">
                            {items.map((item, index) => (
                                <Card key={index} item={item} source={source}/>))}
                        </div>
                    </div>)
                :
                (
                    <div className="main-content-wrapper-mobile">
                        <ul className="sub-categories-list">
                            {items.map((item, index) => (
                                <MobileCard key={index}
                                    source={source}
                                    item={item}/>))}
                        </ul>
                    </div>
                )
        )}
    </AppContext.Consumer>
);

MainContent.propTypes = {
    items: PropTypes.array
};

export default MainContent;
